import { Component, inject } from '@angular/core';
import { CartService } from '../../services/cart.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrl: './cart.component.scss'
})
export class CartComponent {
  protected readonly cartService = inject(CartService);

  promo = '';

  readonly items = this.cartService.items;
  readonly itemCount = this.cartService.itemCount;
  readonly subtotal = this.cartService.subtotal;
  readonly total = this.cartService.total;
  shippingLabel(): string {
    return this.cartService.shippingFree() ? 'Gratis' : '—';
  }

  formatMoney(n: number): string {
    return this.cartService.formatMoney(n);
  }

  inc(id: string): void { this.cartService.inc(id); }
  dec(id: string): void { this.cartService.dec(id); }
  remove(id: string): void { this.cartService.remove(id); }
  clearCart(): void { this.cartService.clear(); }

  applyPromo(): void {
    // Placeholder
  }

  noop(event: Event): void {
    event.preventDefault();
  }
}
